var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1260_10450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H7.5C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5L0 22.5C0 24.4891 0.790176 26.3968 2.1967 27.8033C3.60322 29.2098 5.51088 30 7.5 30H22.5C24.4891 30 26.3968 29.2098 27.8033 27.8033C29.2098 26.3968 30 24.4891 30 22.5V7.5C30 5.51088 29.2098 3.60322 27.8033 2.1967C26.3968 0.790176 24.4891 0 22.5 0V0ZM28.5938 22.5C28.5919 24.1156 27.9493 25.6645 26.8069 26.8069C25.6645 27.9493 24.1156 28.5919 22.5 28.5938H7.5C5.88441 28.5919 4.33552 27.9493 3.19312 26.8069C2.05073 25.6645 1.40811 24.1156 1.40625 22.5V7.5C1.40811 5.88441 2.05073 4.33552 3.19312 3.19312C4.33552 2.05073 5.88441 1.40811 7.5 1.40625H22.5C24.1156 1.40811 25.6645 2.05073 26.8069 3.19312C27.9493 4.33552 28.5919 5.88441 28.5938 7.5V22.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3281 20.3334L9.66656 8.67188H14.2795V7.26562H7.26562V14.2795H8.67188V9.66609L20.3339 21.3281H15.7205V22.7344H22.7344V15.7205H21.3281V20.3334Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1260_10450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.4fa1684e02d2d7f66f499b52b35a8c5d.svg";
export { ForwardRef as ReactComponent };